import * as React from "react";
import { connect } from "react-redux";
import { GlobalState } from "../../store/rootReducer";
import { Dispatch } from "redux";

import { ZAlert } from "@zanichelli/albe-web-components/react";

import { AlertBean } from "../../../beans";

// import { Wrap } from "./styles";

// import i18next from "i18next";
import { withTranslation, WithTranslation } from "react-i18next";
import { AlertType } from "@zanichelli/albe-web-components";

type Props = {
  alerts: AlertBean[];
} & WithTranslation;

type State = {};

class Alert extends React.Component<Props, State> {
  public readonly state: State = {};

  sortData() {
    const { alerts } = this.props;
    return alerts.sort((a: AlertBean, b: AlertBean) => {
      if (!a.priority) a.priority = 0;
      if (!b.priority) b.priority = 0;
      return b.priority - a.priority;
    });
  }

  render() {
    const orderedData = this.sortData();
    if (!orderedData.length) return null;

    return orderedData.map((item: AlertBean) => (
      <ZAlert type={AlertType.ERROR}>{item.message}</ZAlert>
    ));
  }
}

function mapStateToProps(state: GlobalState) {
  return {
    alerts: state.alerts.alerts,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {};
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Alert));
